<template>
  <div :class="ismobile ? 'works' : 'worksmo'">
    <div class="title">{{ rows.name }}</div>
    <div class="work_main">
      <div class="work_img">
        <img
          class="imgs"
          :src="'https://hcrl.huicairen.net' + rows.img"
          alt=""
        />
      </div>
      <div class="rights">
        <div class="right_top">
          <div class="item_left">
            <img
              class="left_icon"
              src="../static/icon_position_gong_ico.png"
              alt=""
            />
            综合工资：<span style="color: #da251c">{{ rows.salary }}</span>
            元/月
          </div>
          <div
            @click="todetails"
            class="item_left"
            style="color: #da251c; cursor: pointer"
          >
            查看详情

            <img
              class="more_icon"
              src="../static/icon_position_twomore_ico.png"
              alt=""
            />
          </div>
        </div>
        <div class="item_left item_margin">
          <img
            class="left_icon"
            src="../static/icon_position_dizhi_ico.png"
            alt=""
          />
          工作地点：{{ rows.address }}
        </div>
        <div class="right_top">
          <div class="label_list">
            <div v-for="item in list" :key="item" class="labels">
              {{ item }}
            </div>
          </div>
          <div class="frees" @click="frestap">免费报名</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: {
    rows: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,
    };
  },
  computed: {
    list() {
      return this.rows.flag.split(",");
    },
    ismobile() {
      console.log(this.windowWidth);
      if (this.windowWidth > 500) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    todetails() {
      this.$emit("todetails", this.rows);
    },
    frestap() {
      this.$emit("free", this.rows);
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
};
</script>
<style lang="less" scoped>
// 手机
.worksmo {
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid #c9c9c9;
  box-sizing: border-box;
  height: auto;
  .title {
    font-size: 20px;
    color: #333333;
    margin-bottom: 10px;
  }
  .imgs {
    width: 100%;
    height: 100%;
  }
  .rights {
    width: 100%;
    // height: 90px;
  }
  .work_img {
    width: 100%;
    height: auto;
    // margin-right: 15px;
  }
  .right_top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item_margin {
    margin-top: 16px;
    margin-bottom: 30px;
  }
  .item_left {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333333;
    .left_icon {
      width: 16px;
      height: 18px;
      margin-right: 5px;
    }
    .more_icon {
      width: 12px;
      height: 12px;
      margin-left: 5px;
    }
  }
  .frees {
    width: 120px;
    height: 40px;
    background: #da251c;
    border-radius: 10px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  .label_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 100%;
    // height: auto;
  }
  .labels {
    width: 60px;
    height: 30px;
    background: rgba(218, 37, 28, 0.2);
    border-radius: 6px;
    font-size: 10px;
    color: #da251c;
    text-align: center;
    line-height: 30px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
// pc
.works {
  width: 100%;
  padding: 50px 0;
  border-bottom: 1px solid #c9c9c9;
  box-sizing: border-box;
  .imgs {
    width: 280px;
    height: 100%;
  }
  .item_margin {
    margin-top: 30px;
    margin-bottom: 66px;
  }
  .title {
    font-size: 20px;
    color: #333333;
    margin-bottom: 20px;
  }
  .work_main {
    display: flex;
    align-items: center;
  }
  .rights {
    width: 100%;
    height: 180px;
  }
  .work_img {
    width: 280px;
    height: 180px;
    margin-right: 30px;
  }
  .right_top {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item_left {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333333;
    .left_icon {
      width: 16px;
      height: 18px;
      margin-right: 10px;
    }
    .more_icon {
      width: 12px;
      height: 12px;
      margin-left: 10px;
    }
  }
  .frees {
    width: 120px;
    height: 40px;
    background: #da251c;
    border-radius: 10px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  .label_list {
    display: flex;
    align-items: center;
  }
  .labels {
    width: 80px;
    height: 30px;
    background: rgba(218, 37, 28, 0.2);
    border-radius: 6px;
    font-size: 16px;
    color: #da251c;
    text-align: center;
    line-height: 30px;
    margin-right: 10px;
  }
}
</style>
